import React, { useState } from "react";

type Slab = "10000" | "25000" | "50000" | "100000";

interface RateData {
  [key: string]: string;
}

interface RateItem {
  type: string;
  rates: RateData;
}

const slabOptions: { value: Slab; label: string }[] = [
  {
    value: "10000",
    label: "Upto 10,000 sqft",
  },
  {
    value: "25000",
    label: "Upto 25,000 sqft",
  },
  {
    value: "50000",
    label: "Upto 50,000 sqft",
  },
  {
    value: "100000",
    label: "Upto 100,000 sqft",
  },
];

const rateData: RateItem[] = [
  {
    type: "Residential",
    rates: {
      "10000": "Rs. 30,000/-",
      "25000": "Rs. 3 / sqft",
      "50000": "Rs. 3 / sqft",
      "100000": "Rs. 3 / sqft",
    },
  },
  {
    type: "Commercial",
    rates: {
      "10000": "Rs. 28,000/-",
      "25000": "Rs. 2.75 / sqft",
      "50000": "Rs. 2.5 / sqft",
      "100000": "Rs. 2.5 / sqft",
    },
  },
  {
    type: "Institutional",
    rates: {
      "10000": "Rs. 35,000/-",
      "25000": "Rs. 3.5 / sqft",
      "50000": "Rs. 3.25 / sqft",
      "100000": "Rs. 3 / sqft",
    },
  },
  {
    type: "Industrial",
    rates: {
      "10000": "Rs. 25,000/-",
      "25000": "Rs. 2.5 / sqft",
      "50000": "Rs. 2.25 / sqft",
      "100000": "Rs. 2 / sqft",
    },
  },
];

const BoqTablePage: React.FC = () => {
  const [selectedSlab, setSelectedSlab] = useState<Slab>("10000");

  return (
    <div className="cost-react-mobile w-full max-w-full bg-gray-100 p-2 sm:p-4 md:p-8">
      
      {/* Main Container */}
      <div className="mx-auto w-full max-w-3xl">

        {/* Page Title */}
        <h1 className="mb-4 text-center text-2xl font-bold text-gray-800 sm:mb-6">
          BoQ Rates
        </h1>

        {/* Rate Card */}
        <div className="w-full max-w-full overflow-hidden rounded-lg border border-gray-300 bg-white shadow-sm">

          {/* Section Title */}
          <div className="border-b border-gray-200 px-3 py-3 sm:px-6 sm:py-4">
            <h2 className="text-base font-semibold italic leading-6 text-gray-800 sm:text-lg">
              Rates for Civil works (warmshell + finishes):
            </h2>
          </div>

          {/* Header */}
          <div className="grid w-full grid-cols-2 border-b border-gray-200 bg-gray-50 px-3 py-3 sm:px-6">

            {/* Type */}
            <div className="flex items-center text-sm font-semibold text-gray-700 sm:text-base">
              Type
            </div>

            {/* Slab Dropdown */}
            <div className="min-w-0">
              <select
                value={selectedSlab}
                onChange={(event) =>
                  setSelectedSlab(event.target.value as Slab)
                }
                className="w-full max-w-full rounded-md border border-gray-300 bg-white px-2 py-2 text-xs outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 sm:px-3 sm:text-sm"
              >
                {slabOptions.map((option) => (
                  <option
                    key={option.value}
                    value={option.value}
                  >
                    {option.label}
                  </option>
                ))}
              </select>
            </div>

          </div>

          {/* Rates */}
          <div className="w-full">

            {rateData.map((item) => (
              <div
                key={item.type}
                className="grid w-full grid-cols-2 border-b border-gray-100 px-3 py-3 last:border-b-0 sm:px-6"
              >

                {/* Type */}
                <div className="min-w-0 text-sm text-gray-700 sm:text-base">
                  {item.type}
                </div>

                {/* Rate */}
                <div className="min-w-0 text-sm font-medium text-gray-800 sm:text-base">
                  {item.rates[selectedSlab]}
                </div>

              </div>
            ))}

          </div>

        </div>
      </div>
    </div>
  );
};

export default BoqTablePage;